<template>
  <base-modal
    class="media_modal"
    @close="$emit('close')"
  >
    <template #heading>
      Upload Media
    </template>
    <p class="content_policy">
      Make sure your photos follow Google’s guidelines and requirements,
      and comply with
      <a
        href="https://support.google.com/business/answer/10693375"
        target="_blank"
      >
        Google's content policy.
      </a>
    </p>

    <div class="guidelines_accordion">
      <div
        class="accordion_header"
        @click="showGuidelines = !showGuidelines"
      >
        <h5>Google's Photo Guidelines</h5>
        <i class="icon arrow_down_icon caret" />
      </div>
      <accordion-transition>
        <div
          v-if="showGuidelines"
          class="guidelines"
        >
          <div class="scroll_container">
            <div class="photo_guidelines">
              <h5>Photo guidelines</h5>
              <p>Your photos look best on Google if they meet the following standards:</p>

              <ul>
                <li><strong>Format:</strong> JPG or PNG.</li>
                <li><strong>Size:</strong> Between 10 KB and 5 MB.</li>
                <li><strong>Recommended resolution:</strong> 720 px tall, 720 px wide.</li>
                <li><strong>Minimum resolution:</strong> 250 px tall, 250 px wide.</li>
                <li>
                  <strong>Quality:</strong> The photo should be in focus and well lit, and have no significant
                  alterations
                  or excessive use of filters. In other words, the image should represent reality.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </accordion-transition>
    </div>

    <custom-select
      v-model="mediaCategory"
      :close-on-select="true"
      :options="mediaCategories"
      :searchable="true"
      label="Select media category"
      placeholder="No Category (Appears as 'additional')"
    />

    <dropzone-area
      :additional-xhr-data="{ category: mediaCategory }"
      :endpoint="`/gbp/upload-media-item/${selectedLocation}`"
      accepted-files="image/png, image/jpg, image/jpeg"
      invalid-file-type-message="Google does not accept this file type"
      @close="$emit('close')"
      @upload-completed="fetchMediaItems(selectedLocation)"
    />
  </base-modal>
</template>

<script>
import BaseModal from "../../../global/modals/BaseModal";
import DropzoneArea from "../../../global/forms/DropzoneArea";
import AccordionTransition from "../../../../../views/reports/components/global/transitions/AccordionTransition";
import CustomSelect from "../../../../../views/reports/components/global/forms/CustomSelect";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    AccordionTransition,
    DropzoneArea,
    BaseModal,
    CustomSelect,
  },
  emits: ['close'],
  data() {
    return {
      showGuidelines: false,
      mediaCategory: null,
      mediaCategories: {
        EXTERIOR: 'Exterior photo',
        INTERIOR: 'Interior photo',
        AT_WORK: 'At-work photo',
        FOOD_AND_DRINK: 'Food and drink photo',
        MENU: 'Menu photo',
        COMMON_AREA: 'Common area photo',
        ROOMS: 'Rooms photo',
        TEAMS: 'Teams photo',
      },
    }
  },
  computed: {
    ...mapGetters('businessProfile', [
      'selectedLocation',
    ]),
  },
  methods: {
    ...mapActions('businessProfile', [
      'fetchMediaItems',
    ]),
  }
}
</script>

<style lang="scss" scoped>
.content_policy {
  margin: 0 .5rem;
}

.guidelines_accordion {
  background-color: #FBFAFA;
  border-radius: 0.75rem;
  padding: 0.5rem 2rem;
  margin-bottom: 1rem;

  .accordion_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    h5 {
      margin-bottom: 0;
    }
  }

  .guidelines {
    margin-top: 1rem;
    transition: 3ms;

    .scroll_container {
      max-height: 30vh;
      overflow-y: auto;
    }
  }
}
</style>
